<template>
    <div class="">
        <div class="refcontent" style="padding-top: 100px;">
            <div class="standard">
                <h1 class="noborder zzgray">
                    <span v-html="project.title.rendered"></span>
                    <div class="h3 zzgray noborder" v-html="project.acf.Unterzeile"></div>

                </h1>
            </div>
        </div>
        <div class="refcontent">
            <div class="standard mainimage">
                <div class="">
                    <img :src="project._embedded['wp:featuredmedia']['0'].source_url" alt="" class="shadowed">
                </div>
            </div>
        </div>
        <div class="info row" v-if="project.acf.info.kunde || project.acf.info.branche">
            <div class="col-60 col-md-10">
                <div class="h4">Branche</div>
                <div v-html="project.acf.info.branche">
                </div>
            </div>
            <div class="col-60 col-md-20">
                <div class="h4">Kunde</div>
                <div v-html="project.acf.info.kunde">
                </div>
            </div>
            <div class="col-60 col-md-20">
                <div class="h4">Aufgaben</div>
                <div>
                    <div class="aufgabe" v-for="a in project.acf.info.aufgaben" v-html="a.aufgabe">
                    </div>
                </div>
            </div>
            <div class="col-60 col-md-10">
                <div class="h4">Zeitraum</div>
                <div v-html="project.acf.info.zeitraum">
                </div>
            </div>
        </div>
        <div class="refcontent">
            <div class="standard">
                <div v-html="project.content.rendered" class="text">
                </div>
            </div>
        </div>
        <Blocks :blocks="project.acf.zeile"></Blocks>
    </div>
</template>
<script>
    import store from '@/store'
    import Velocity from "velocity-animate";
    import Blocks from '@/components/Blocks/Blocks.vue'

    export default {
        Velocity,
        store,
        name: "Referenz",
        components: {Blocks},
        props: ['project'],
        methods: {},
        created() {
            document.body.classList.remove('nooverflow');
        },
        mounted() {
                document.body.classList.remove('nooverflow');

        }
    }
</script>
<style scoped lang="scss">
    h1{
        font-family: $zilla;

        color: $zzgray;
        line-height: 130%;
        letter-spacing: 0.02em;
        /*text-align: center;*/
        padding: 50px 0;
        border-bottom: none;

        .h3 {
            margin-top: 10px;
            border: none;
            color: $zzgray;
        }
    }

    .mainimage {
        max-width: 100%;
        padding: 0 20px;

        img {
            max-width: 100%;
        }
    }

    .referenz {
        .refcontent {
            display: flex;
            justify-content: center;

            .standard {
                max-width: 100%;
                width: 1080px;
                padding: 0 20px;
                height: auto;
            }
        }

        position: relative;
        /*top: 0;*/
        width: 100%;
        opacity: 1;
        background-color: #fff;
        /*height: calc(100vh - 70px);*/
        &.v-enter-to {
        }

        font-family: $sansmed;

        .info {
            position: relative;
            /*padding: 0 10%;*/
            width: 100%;
            max-width: 1080px;
            font-family: $sans;

            margin: 200px auto 0px;
            letter-spacing: 0.02em;
            .header {
                //styleName: <h4> - Abschnittsüberschrift;
                font-size: 14px;
                font-style: normal;
                font-weight: 900;
                line-height: 29px;
                letter-spacing: 0.1em;
                text-align: left;
                text-transform: uppercase;
            }

            //styleName: <nav> - items;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 29px;
            text-align: left;

            .aufgabe {
                line-height: 22px;
                margin-bottom: 7px;
            }
        }
    }
</style>